import { weaponPageColumn } from "../resource/weapon-page-column";
import { NeededColumn } from "./needed-column";

export const weaponPageNeededColumn = new NeededColumn(
  "97433647-378f-42db-a073-0b864e50935b",
  weaponPageColumn,
  "Red Page Needed"
)
